import { Puzzles } from "@prisma/client";
import { StateCreator } from "zustand";

type PuzzleMove = {
    isWrongMove: boolean;
    [key: string]: unknown;
};

type PuzzleState = {
    puzzle: Puzzles | undefined;
    isFinished: boolean;
    result: "success" | "fail" | undefined;
    isScored: boolean;
    moves: PuzzleMove[];
};

type PuzzleStateSlice = {
    puzzleState: PuzzleState;
    setPuzzleState: (puzzleState: PuzzleState) => void;
};

const initialState: PuzzleState = {
    puzzle: undefined,
    isFinished: false,
    result: undefined,
    isScored: false,
    moves: [],
};

const createPuzzleStateSlice: StateCreator<PuzzleStateSlice> = (set) => ({
    puzzleState: initialState,
    setPuzzleState: (data) =>
        set((state) => ({
            puzzleState: { ...state.puzzleState, ...data },
        })),
});

export default createPuzzleStateSlice;
export type { PuzzleStateSlice };
